export enum LanguageKey {
    ENGLISH_US = 'en_US',
    ENGLISH_GB = 'en_GB',
    SPANISH_ES = 'es_ES',
    SPANISH_MX = 'es_MX',
    SPANISH_LA = 'es_LA',
    GERMAN_DE = 'de_DE',
    FRENCH_FR = 'fr_FR',
    FRENCH_CA = 'fr_CA',
    ITALIAN_IT = 'it_IT',
    PORTUGUESE_PT = 'pt_PT',
    RUSSIAN_RU = 'ru_RU',
    TURKISH_TR = 'tr_TR',
    DUTCH_BE = 'nl_BE',
    DUTCH_NL = 'nl_NL',
    POLISH_PL = 'pl_PL',
    VIETNAMESE_VN = 'vi_VN',
    PORTUGUESE_BR = 'pt_BR',
    JAPANESE_JA = 'ja_JA',
}
export function isSupportedLanguage(value: string): value is LanguageKey {
    return Object.values(LanguageKey).includes(value);
}

export type LocalizedString = {
    [key in LanguageKey]?: string;
} & { default: string };

export function getLanguageString(
    localizedString: LocalizedString,
    key: LanguageKey
): string {
    return localizedString[key]
        ? localizedString[key]
        : localizedString.default;
}

export function sliceLanguage(language: string): string {
    const slicedL = Object.values(LanguageKey).find(
        langvalue => langvalue.slice(0, 2) === language.slice(0, 2)
    );
    if (slicedL) {
        return slicedL;
    }
    return language;
}
